//@flow

import styled from "styled-components"
import * as BaseUI from "../UI"

export const TitleText = BaseUI.TitleText

export const TitleDescription = BaseUI.TitleDescription.extend`
  width: 600px;
`

export const ContentContainer = styled.div`
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  position: absolute;
  background: #a5d9f2;
`

export const Titles = styled.div`
  position: absolute;
  top: 104px;
  left: 104px;
  z-index: 2;
`

export const DriveThru = styled.div`
  position: absolute;
  bottom: -2px;
  right: -300px;
  height: 832px;
  width: 2329px;
  z-index: 3;
`

export const Midground = styled.div`
  position: absolute;
  bottom: 30px;
  left: -100px;
  height: 437px;
  width: 2588px;
  z-index: 1;
`

export const Background = styled.div`
  position: absolute;
  bottom: 204px;
  right: 0px;
  height: 530px;
  width: 2135px;
  z-index: 0;
`



// WEBPACK FOOTER //
// ./src/Kiosk/CommitView/Idling/UI.js